module.exports = __webpack_public_path__ + "assets/images/vcr_park-04.b59994e1a28fe43bb6faa5edb1ab3535.svg";